import React from 'react';
import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import App from 'routes';
import { ThemeProvider } from '@mui/material';

import './index.scss';
import theme from 'styles/theme';
import { ApolloProvider } from '@apollo/client';
import { client } from 'graphql/client';
import { Bounce, ToastContainer } from 'react-toastify';

import 'react-toastify/dist/ReactToastify.css';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  // <React.StrictMode>
  <ThemeProvider theme={theme}>
    <ApolloProvider client={client}>
      <App />
      <ToastContainer
        position="top-center"
        autoClose={2000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        draggable
        theme="colored"
        stacked
        transition={Bounce}
        toastStyle={{
          minHeight: 0,
        }}
      />
    </ApolloProvider>
  </ThemeProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
